export default __webpack_public_path__ + "static/media/Chevron right.82e467d0.svg";